import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import { getPathLanguage } from '../../../../utils/params';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import { RedMapPin } from 'assets/images/web-isn';
import { useTranslation } from 'react-i18next';
import OwlCarousel from 'react-owl-carousel2';
import { PROJECT_NAV_LEFT, PROJECT_NAV_RIGHT } from '../../../../utils/constants';

const ProjectList = props => {
  // const language = getLanguage(useLocation());
  const pathLanguage = getPathLanguage(useLocation());
  const { t } = useTranslation();
  const options = {
    margin: 30,
    nav: true,
    navText: [PROJECT_NAV_RIGHT, PROJECT_NAV_LEFT],
    dots: false,
    autoplay: false,
    autoHeight: true,
    // responsive: {},
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    freeDrag: false,
    loop: false,
    responsive: {
      0: {
        items: 1,
        nav: true
      },
      600: {
        items: 2,
        nav: false
      },
      1000: {
        items: 3,
        nav: true,
        loop: false
      }
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h1 className="detail-apartment-title">{t('search_property.featured_projects')}</h1>
          <div className="row">

          </div>
          <div className="row project-list-search">
            <div className="col-12">
              {props.projectList ? (
                <OwlCarousel
                  options={options}
                  className="nav-top owl-carousel owl-theme owl-loaded owl-drag owl-home-properties"
                >
                  {props.projectList.length > 0
                    ? props.projectList.map((item, index) => {
                      return (
                        <div key={index} className="col-item">
                          <div className="block-inner border-radius-none">
                            <div className="block-image">
                              <Link
                                to={`${pathLanguage}/featured-projects/detail/overview/${item.id}/${item.slug}?${props.category}=1`}
                                className="block-handle-click"
                              >
                                <img className="border-radius-none" alt={'project' + index} src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`} />
                                {/* <LazyLoadImage alt="" src={item.blogThumnail} effect="blur" /> */}
                              </Link>
                            </div>
                            <Link
                              to={`${pathLanguage}/featured-projects/detail/overview/${item.id}/${item.slug}?${props.category}=1`}
                              className="d-flex flex-column justify-content-between block-text blog-description text-decoration-none"
                            >
                              <div>
                                <div
                                  className="project-box-title-hover"
                                  to={`${pathLanguage}/featured-projects/detail/overview/${item.id}/${item.slug}?${props.category}=1`}
                                >
                                  <h4 className="text-decoration-none text-truncate-box-title-name">{item.projectName}</h4>
                                </div>
                              </div>
                              <div
                                className="pt-2"
                                to={`${pathLanguage}/featured-projects/detail/overview/${item.id}/${item.slug}?${props.category}=1`}
                              >
                                <div className="d-flex mt-2 align-items-center">
                                  <img className="mr-1 width-fit-content" src={RedMapPin} alt="location" />
                                  <span className="mr-3 font-noto-sans-jp text-truncate-address">
                                    {t('search_property.address')}
                                    {item.address}
                                  </span>
                                </div>
                                <div className="d-flex mt-3 align-items-center">
                                  <span className="mr-3 font-noto-sans-jp required-mask">
                                    {item.quantity > 1 ? item.quantity + t('search_property.listings') : item.quantity + t('search_property.listing')}
                                  </span>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      );
                    })
                    : ''}
                </OwlCarousel>
              ) : ''}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProjectList);
